import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchProfileUserInformation = createAsyncThunk(
  'profileUsers/fetchInformation',
  async ({ userEmail, employeeId }, { signal, rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_URL}/api/Profile/users/information`, {
        signal,
        headers: { 'Content-Type': 'application/json' },
        params: { userEmail, EmployeeID: employeeId },
      });
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('profileUsers/fetchInformation failed', e);
      return rejectWithValue(e?.message || 'Failed to fetch employee information');
    }
  }
);

export const fetchProfileUserProfilePicture = createAsyncThunk(
  'profileUsers/fetchProfilePicture',
  async ({ userEmail, employeeId }, { signal, rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_URL}/api/Profile/users/ProfilePicture`, {
        signal,
        headers: { 'Content-Type': 'application/json' },
        params: { userEmail, EmployeeID: employeeId },
      });
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('profileUsers/fetchProfilePicture failed', e);
      return rejectWithValue(e?.message || 'Failed to fetch profile picture');
    }
  }
);

export const updateProfileUserInformation = createAsyncThunk(
  'profileUsers/updateInformation',
  async ({ employeeId, userEmail, actionType, sectionName, updatedValues, rowId }, { signal, rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${API_URL}/api/Profile/users/UpdatingInformation`,
        {
          EmployeeID: employeeId,
          UserEmail: userEmail,
          Action: actionType,
          SectionName: sectionName,
          UpdatedValues: updatedValues,
          RowID: rowId,
        },
        { signal, headers: { 'Content-Type': 'application/json' } }
      );
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('profileUsers/updateInformation failed', e);
      return rejectWithValue(e?.response?.data?.message || e?.message || 'Failed to update employee information');
    }
  }
);

const slice = createSlice({
  name: 'profileUsers',
  initialState: { error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => action.type.startsWith('profileUsers/') && action.type.endsWith('/rejected'),
      (state, action) => {
        if (action?.meta?.aborted) return;
        state.error = action.payload || action.error?.message || null;
      }
    );
  },
});

export default slice.reducer;


